function getTR(code) {
  const trc = [
    '572 Highest known TRCODE ', /* 000 -- */
    'Share Withdrawal (Cash)  ', /* 001 SW */
    'Share Withdrawal (Check) ', /* 002 WK */
    'Share Deposit (Credit)   ', /* 003 SD */
    'Share Deposit (Check)    ', /* 004 SK */
    'Miscellaneous Income #1 *', /* 005 V1 */
    'Miscellaneous Income #2 *', /* 006 V2 */
    'Loan Advance (Cash)      ', /* 007 LC */
    'Loan Advance (Check)     ', /* 008 LA */
    'Loan Payment (Credit)    ', /* 009 PC */
    'Loan Payment (Check)     ', /* 010 PK */
    'Loan Payoff (Credit)     ', /* 011 PO */
    'Loan Payoff (Check)      ', /* 012 OK */
    'New Loan (Cash)          ', /* 013 NC */
    'New Loan (Check)         ', /* 014 NL */
    'Loan-Advance (Transfer)  ', /* 015 OL */
    'New Loan (Transfer)      ', /* 016 LX */
    'Miscellaneous Credit     ', /* 017 AC */
    'Miscellaneous Debit      ', /* 018 AD */
    'Cash Balancing Adjustment', /* 019 BA */
    'Misc Credit Adjustment   ', /* 020 CA */
    'Printing/Copying Charge  ', /* 021 CC */
    'Certificate-Dividend     ', /* 022 CD */
    'Share Correcting Entry   ', /* 023 CE */
    'Late-Payment-Charge      ', /* 024 CG */
    'Closed Account           ', /* 025 CL */
    'Loan Charge-Off          ', /* 026 CO */
    'Withdrawal-Club-Payout   ', /* 027 CP */
    'Misc Credit Return       ', /* 028 CR */
    'Certificate-Dividend-Xfer', /* 029 CT */
    'Misc Debit Adjustment    ', /* 030 DA */
    'Share (Paid Draft)       ', /* 031 DP */
    'Misc Debit Return        ', /* 032 DR */
    'Share Deposit (Transfer) ', /* 033 DT */
    'Share Dividend           ', /* 034 DV */
    'Share (Fees or Charges)  ', /* 035 FF */
    'Share (Insurance Premium)', /* 036 IP */
    "'NSF'-Returned-Draft     ", /* 037 NS */
    'Share Payroll Deposit    ', /* 038 PD */
    'Draft Photo Copy Charge  ', /* 039 PH */
    'Payoff-Refinance         ', /* 040 PR */
    'Payment From Shares      ', /* 041 PS */
    'Payment (From Shares)    ', /* 042 PT */
    'Interest Rebate          ', /* 043 RB */
    'Share (Insurance Refund) ', /* 044 RF */
    'Services Adjustment      ', /* 045 SA */
    'Stop-Payment-Request     ', /* 046 SP */
    'Share Transfer To Loans  ', /* 047 TL */
    'Unauthorized Signature   ', /* 048 US */
    'Share Withdrawal-Transfer', /* 049 WT */
    'Share Payroll Posting    ', /* 050 PP */
    'Credit Bureau Charge     ', /* 051 CB */
    'Notary Documentary Fee   ', /* 052 BF */
    'Early Withdrawal Fee     ', /* 053 AW */
    'ReDeposit Void Check     ', /* 054 VD */
    'Insurance Payment(Shares)', /* 055 SI */
    'Miscellaneous-Expense #1*', /* 056 X1 */
    'Miscellaneous-Expense #2*', /* 057 X2 */
    'Miscellaneous-Expense #3*', /* 058 X3 */
    'Loan Payment (Payroll)   ', /* 059 PL */
    'Share Escrow Insurance   ', /* 060 EI */
    'Share Escrow Taxes       ', /* 061 ET */
    'Share Overdraft (NSF) Fee', /* 062 OD */
    'IRA Maintenance Fee      ', /* 063 IF */
    'Draft Printing Charge    ', /* 064 DC */
    'Share Deduction UnionDues', /* 065 UD */
    'Share (Coverall Charge)  ', /* 066 CV */
    'Miscellaneous Fee/Charge ', /* 067 FC */
    'Minimum Balance Fee      ', /* 068 MB */
    'Loan Correcting Entry    ', /* 069 CY */
    'Loan Insurance Premium   ', /* 070 LI */
    'Loan Insurance Refund    ', /* 071 LR */
    'Returned-Draft-Charge    ', /* 072 SF */
    'Backup Withholding (IRS) ', /* 073 BW */
    'Stop-Pay-Request-Fee     ', /* 074 PF */
    'Check-Cashed             ', /* 075 KC */
    "'ACH'-debit/credit-entry ", /* 076 AH */
    'SUSPENSE                 ', /* 077 $R */
    '** -- Cash-Received -- **', /* 078 HR */
    '** - Check-Received -- **', /* 079 KR */
    '**** TOTAL-RECEIVED *****', /* 080 TR */
    '******* CASH-BACK *******', /* 081 BK */
    '***** Bank-Deposit ******', /* 082 BD */
    'Phone Withdrawal-Transfer', /* 083 S1 */
    'Phone Deposit-Transfer   ', /* 084 S2 */
    'Phone Payment-Transfer   ', /* 085 S3 */
    'Phone Loan-Advance       ', /* 086 S4 */
    'Beginning-Cash-Drawer    ', /* 087 D1 */
    'Cash-Drawer-REplenishment', /* 088 D2 */
    'Cash-Drawer-DEplenishment', /* 089 D3 */
    'Ending-Cash-Drawer       ', /* 090 D4 */
    'Certificate-Transfer     ', /* 091 ZW */
    'Open-IRA-Certificate     ', /* 092 OI */
    'Xfer-To-Accts-Receivable*', /* 093 AV */
    'Item Purchase #1         ', /* 094 I1 */
    'Item Purchase #2         ', /* 095 I2 */
    'Cash-Drawer SHORTAGE     ', /* 096 D8 */
    'Share Correcting Entry   ', /* 097 CW */
    "G.L. Check Rec'd / Disb'd", /* 098 GR */
    "G.L. Cash Rec'd / Disb'd ", /* 099 GC */
    'Dormant Account Fee      ', /* 100 DF */
    'Share Payroll Deposit    ', /* 101 PV */
    'Share Payroll Deposit    ', /* 102 PI */
    'Normal Distribution Check', /* 103 RA */
    'Delinquent-Loan-Status   ', /* 104 DQ */
    'Loan-Collection-Charges  ', /* 105 LL */
    'Loan-Legal-Fees/Charges  ', /* 106 LF */
    'Loan-Reposession-Charges ', /* 107 RC */
    'Loan-Appraisal-Charges   ', /* 108 AR */
    'Mortgage-Processing-Fees ', /* 109 MF */
    'Mortgage-Points-Assesment', /* 110 MP */
    'Loan-Disbursement-Check  ', /* 111 LD */
    'Item Purchase #3         ', /* 112 I3 */
    'Xfer-To-Accts-Payable   *', /* 113 AT */
    'Insurance Payment        ', /* 114 IL */
    'Draft-Advance-Fee        ', /* 115 AX */
    'Negative-Balance-Fee     ', /* 116 NF */
    'Overdraft-Transfer       ', /* 117 OT */
    'Overdraft-Loan-Advance   ', /* 118 OA */
    'Draft-Transfer-Fee       ', /* 119 OF */
    'Payment (Interest-Adjust)', /* 120 AJ */
    "'ACH'-Deposit-Return     ", /* 121 21 */
    "'ACH'-Share-Deposit      ", /* 122 22 */
    "'ACH'-Deposit-Notice     ", /* 123 23 */
    "'ACH'-Share-(CR)-Reserved", /* 124 24 */
    "'ACH'-Share-(DB)-Reserved", /* 125 25 */
    "'ACH'-Withdrawal-Return  ", /* 126 26 */
    "'ACH'-Share-Withdrawal   ", /* 127 27 */
    "'ACH'-Withdrawal-Notice  ", /* 128 28 */
    'Tax-Filing-Charge        ', /* 129 29 */
    'Tax-Loan-Advance-Fee     ', /* 130 30 */
    'State-Backup-Withholding ', /* 131 ST */
    'Withdrawal-Utility-Paymnt', /* 132 32 */
    'Transfer (Dormant Shares)', /* 133 DS */
    'Corporate Checking Credit', /* 134 IC */
    "'ATM'-Deposit-Entry      ", /* 135 TE */
    'Rental-Income           *', /* 136 OR */
    "'ACH'-Deposit-Entry      ", /* 137 DE */
    "'ACH'-Withdrawal-Entry   ", /* 138 WE */
    'Open-IRA-ShareTRADITIONAL', /* 139 OJ */
    "'ACH'-Transfer-To-Loans  ", /* 140 SL */
    'Loan-Insurance-Addon     ', /* 141 IA */
    'RolloverContributionCheck', /* 142 ZC */
    'Contribution RolloverChck', /* 143 ZD */
    'Contribution (Prior-Year)', /* 144 ZE */
    'ContributionPriorYearChck', /* 145 ZF */
    'Certificate-Transfer     ', /* 146 ZG */
    'DirectTransferContributon', /* 147 ZH */
    'Early-Withdrawal-Penalty ', /* 148 ZI */
    'RolloverContributionXfer ', /* 149 ZJ */
    'ContributionPriorYearXfer', /* 150 ZK */
    'Normal Distribution Xfer ', /* 151 ZL */
    'RolloverDistributionXfer ', /* 152 ZM */
    'Death-Distribution-Check ', /* 153 ZN */
    'Distribution (Disability)', /* 154 ZO */
    'DirectTransferDistributon', /* 155 ZP */
    'RolloverDistributionCheck', /* 156 ZQ */
    'Distribution-ECCY-Code8  ', /* 157 ZR */
    'Distribution-ECPY-CodeP  ', /* 158 ZS */
    'FedTaxWithheld(NormalDis)', /* 159 ZV */
    'Share-Maintenance-Fee    ', /* 160 SM */
    "'ACH'-Withdrawal-Transfer", /* 161 TS */
    "'ACH'-Payment-From-Shares", /* 162 LT */
    "'ACH'-Deposit-Transfer   ", /* 163 TF */
    'New-Member-Fee           ', /* 164 NM */
    'Excess-Withdrawal-Fee    ', /* 165 EW */
    'Excess-Paid-Draft-Fee    ', /* 166 EP */
    'Minimum-Share-Balance-Fee', /* 167 UF */
    "'ATM'-Usage-Fee          ", /* 168 AF */
    "'ATM'-Debit/Credit-Entry ", /* 169 TM */
    'Debit-Card Sales-Draft   ', /* 170 70 */
    "'ATM'-Deposit-Return     ", /* 171 71 */
    "'ATM'-Share-Deposit      ", /* 172 72 */
    "'ATM'-Deposit-Notice     ", /* 173 73 */
    'Debit-Card Cash-Advance  ', /* 174 74 */
    'VISA Cash-Advance        ', /* 175 75 */
    "'ATM'-Withdrawal-Return  ", /* 176 76 */
    "'ATM'-Share-Withdrawal   ", /* 177 77 */
    "'ATM'-Withdrawal-Notice  ", /* 178 78 */
    'Debit-Card (Credit)      ', /* 179 79 */
    "'ATM'-Withdrawal-Entry   ", /* 180 AM */
    'Closed-Share-Account     ', /* 181 SC */
    "Draft 'NSF' Returned     ", /* 182 NZ */
    "Returned 'NSF' Draft     ", /* 183 RZ */
    "Investment Income Rec'd *", /* 184 VI */
    'Charge-Off Subsidiary    ', /* 185 RV */
    'G.L. Check Disbursement  ', /* 186 GD */
    '...not in use...         ', /* 187 87 */
    'Cancel-Stop-Pay-Request  ', /* 188 XS */
    'Currency-Return          ', /* 189 D6 */
    'Loan-Interest-Income     ', /* 190 II */
    'Money-Order-Check        ', /* 191 OC */
    'Money-Order-Purchase     ', /* 192 WM */
    'Money-Order-Fee          ', /* 193 WF */
    'Travelers-Check-Purchase ', /* 194 TC */
    'Travelers-Check-Fee      ', /* 195 CF */
    'Ticket-Purchase-Type#1   ', /* 196 T1 */
    'Ticket-Purchase-Type#2   ', /* 197 T2 */
    'Ticket-Purchase-Type#3   ', /* 198 T3 */
    'Ticket-Purchase-Type#4   ', /* 199 T4 */
    'Ticket-Sales-Charge      ', /* 200 TP */
    'Returned-Check-(Deposit) ', /* 201 FD */
    'Returned-Check-(Payment) ', /* 202 FP */
    'Withdrawal-VISA-Payment  ', /* 203 VP */
    'VISA Card Loan Advance   ', /* 204 VL */
    'Counter Paid Draft       ', /* 205 TD */
    'Cash-Drawer OVERAGE      ', /* 206 D7 */
    'Loan-Origination-Fee     ', /* 207 LO */
    'Charge-Off-Recovery      ', /* 208 RY */
    'Loan-Application-Fee     ', /* 209 AL */
    'Loan-Processing-Fees     ', /* 210 LS */
    'Loan-Recovery-Costs      ', /* 211 RL */
    'Collateral-Insurance     ', /* 212 CI */
    'Collateral-Repair-Costs  ', /* 213 RP */
    'Wire-Transfer-Deposit    ', /* 214 XD */
    'Wire-Transfer-Withdrawal ', /* 215 XW */
    'Wire-Transfer-Fee        ', /* 216 XF */
    'Returned-Check-Charge    ', /* 217 XC */
    'Employee Payroll Deposit ', /* 218 ED */
    'Miscellaneous Loan Charge', /* 219 ML */
    'Miscellaneous Income #3 *', /* 220 VC */
    'Returned-Check-Charge    ', /* 221 XL */
    'Dividend-Penalty         ', /* 222 PN */
    'Check-Cashing-Charge     ', /* 223 KF */
    'Reconciliation-Fee       ', /* 224 RE */
    "'ATM'-Hot-Card-Fee       ", /* 225 HC */
    "'ATM'-Card-ReplacementFee", /* 226 XR */
    "'ATM'-Transaction-Fee    ", /* 227 XT */
    "'ATM'-Transfer-Fee       ", /* 228 XA */
    "'ATM'-Balance-Inquiry-Fee", /* 229 BL */
    'Loan-Recording-Fee       ', /* 230 RD */
    'Mortgage-Release-Fee     ', /* 231 MR */
    'Loan-Advance (Transfer)  ', /* 232 RT */
    'Draft-Returned-Debit     ', /* 233 RI */
    'Draft-Unposted-Debit     ', /* 234 DU */
    'Overdraft-Transfer       ', /* 235 OX */
    'Draft-Returned-Credit    ', /* 236 XI */
    'Draft-Unposted-Credit    ', /* 237 XU */
    'CertifiedCheckWithdrawal ', /* 238 CS */
    'Certified-Check-Fee      ', /* 239 HF */
    'Returned-Draft           ', /* 240 DD */
    'Closed-Account-Fee       ', /* 241 CJ */
    'Prior-Loan-Refinance     ', /* 242 FA */
    'StudentLoanGuaranteeFee  ', /* 243 SG */
    'StudentLoanOriginationFee', /* 244 SO */
    "'ATM'-Overdraft-Charge   ", /* 245 AO */
    'Loan Title Processing Fee', /* 246 TT */
    'Stamp Purchase (Withdraw)', /* 247 WP */
    'Void-Check (Draft)       ', /* 248 VK */
    'Open-New-Share-Account   ', /* 249 OS */
    'Insurance-Refund-Deposit ', /* 250 RK */
    'FedTaxWithheld(EarlyWdwl)', /* 251 TW */
    'Early Equal Periodic Pymt', /* 252 EE */
    'FedTaxWithheld(EqualPymt)', /* 253 TA */
    'EqualPeriodicPaymentXfer ', /* 254 IX */
    'Cash-Delivery            ', /* 255 D5 */
    'Certificate-Renewal      ', /* 256 CN */
    "'ATM' CASH-REPLENISHMENT ", /* 257 D9 */
    'Paid - Escrow-Insurance  ', /* 258 PE */
    'Paid - Escrow-Taxes      ', /* 259 PX */
    'Write-Off Share Overdraw ', /* 260 WO */
    'Loan-Prepaid-Interest    ', /* 261 MI */
    'Foreign-Currency-Adjust  ', /* 262 GN */
    'Money-Order-Check        ', /* 263 F0 */
    'Branch Deposit (Credit)  ', /* 264 B1 */
    'Branch Withdrawal        ', /* 265 B2 */
    'Branch Payment (Credit)  ', /* 266 B3 */
    'Branch loan Advance      ', /* 267 B4 */
    'Loan Payoff (Transfer)   ', /* 268 XP */
    'Corporate Money-Order CR ', /* 269 MC */
    'Charge-off Loan Re-entry ', /* 270 OE */
    'Agency Collection Payment', /* 271 GP */
    'Agency Charge Withheld   ', /* 272 GW */
    "'ACH'-(NSF)-Fee          ", /* 273 HE */
    "'ATM' (NSF) Fee          ", /* 274 ME */
    'Savings Bond Purchase    ', /* 275 BP */
    'Savings Bond Redeemed    ', /* 276 BR */
    'Savings Bond Earnings    ', /* 277 BE */
    'Money-Order-Purchase     ', /* 278 F1 */
    'Money-Order-Fee          ', /* 279 F2 */
    'Travelers-Check-Purchase ', /* 280 F3 */
    'Travelers-Check-Fee      ', /* 281 F4 */
    'CertifiedCheckWithdrawal ', /* 282 F5 */
    'Certified-Check-Fee      ', /* 283 F6 */
    'Funds-Recd-VISA-Payment  ', /* 284 F7 */
    'Mortgage-Closing-Costs   ', /* 285 MG */
    'Closing-Costs-Paid       ', /* 286 CM */
    'Point of Sale - Purchase ', /* 287 P1 */
    'Point of Sale - Refund   ', /* 288 P2 */
    'Phone VISA Payment       ', /* 289 S5 */
    "'ATM'-Card-Issue-Fee     ", /* 290 IS */
    'Real Estate Taxes        ', /* 291 TX */
    'Real Estate Insurance    ', /* 292 IE */
    "'ATM'-Inquiry-Fee        ", /* 293 Q0 */
    "'ATM'-POS-Fee            ", /* 294 Q1 */
    "'ATM'-Transfer-Fee       ", /* 295 Q2 */
    "'ATM'-Withdrawal-Fee     ", /* 296 Q3 */
    "'ATM'-Deposit-Fee        ", /* 297 Q4 */
    "'ATM'-Pin-Change-Fee     ", /* 298 Q5 */
    "'ATM'-Transaction-Fee    ", /* 299 Q6 */
    "'ATM'-Overdraft-Xfer-Fee ", /* 300 Q7 */
    "'ATM'-Advance-Fee        ", /* 301 Q8 */
    "'ATM'-Misc-Fees          ", /* 302 Q9 */
    'Debit-Card-DB/CR-Entry   ', /* 303 P3 */
    "'POS'-Debit/Credit-Entry ", /* 304 P4 */
    'Insurance Claim Deposit  ', /* 305 DI */
    'Insurance Claim Payment  ', /* 306 LP */
    'Loan-APR-change...       ', /* 307 AQ */
    'Payment (Insurance Claim)', /* 308 PM */
    'Deposit (Insurance Claim)', /* 309 DM */
    "'ATM'-LOAN-PAYMENT       ", /* 310 NT */
    "'ACH'-Revoked-Withdrawal ", /* 311 RR */
    "'ACH'-Revoked-Deposit    ", /* 312 RW */
    "'ACH'-Revoked-Wtdl-Closed", /* 313 RX */
    "'ACH'-Revoked-Crdt-Closed", /* 314 RQ */
    'Warranty-Insurance-Prem  ', /* 315 WI */
    "'ATM'-Withdrawal-Transfer", /* 316 MW */
    "'ATM'-Deposit-Transfer   ", /* 317 MT */
    'Loan Payment (Transfer)  ', /* 318 FX */
    'Collateral Repossessed   ', /* 319 LQ */
    'Food Stamp Deposit       ', /* 320 FS */
    'Loan Interest Refund     ', /* 321 UH */
    "'ATM'-Card-Monthly-Fee   ", /* 322 QA */
    "'Debit-Card' Monthly Fee ", /* 323 QB */
    'Branch Card Loan Payment ', /* 324 B5 */
    'Branch CARD Loan Advance ', /* 325 B6 */
    'Withdrawal-VISA-Payment  ', /* 326 B7 */
    'VISA Loan Advance        ', /* 327 B8 */
    'Direct-VISA-Pymt-Offset  ', /* 328 VO */
    "Open-IRA-Share-'ROTH'    ", /* 329 O2 */
    "Open-IRA-Share'EDUCATION'", /* 330 O3 */
    "Open-IRA-Share-'S.E.P.'  ", /* 331 O4 */
    '-------------------------', /* 332 -- */
    'BONUS DIVIDEND           ', /* 333 BO */
    '-------------------------', /* 334 -- */
    'Certificate Div Check    ', /* 335 C1 */
    "'C1' check printed       ", /* 336 C2 */
    'IRA Disbursement Check   ', /* 337 C3 */
    "'C3' check printed       ", /* 338 C4 */
    'Phone Check Requested    ', /* 339 C5 */
    "'C5' check printed       ", /* 340 C6 */
    'INTERNET Check Requested ', /* 341 C7 */
    "'C7' check printed       ", /* 342 C8 */
    'XMAS Club Payout Check   ', /* 343 E1 */
    "'E1' check printed       ", /* 344 E2 */
    'VacationClub Payout Check', /* 345 E3 */
    "'E3' check printed       ", /* 346 E4 */
    "'E4' reserved            ", /* 347 E5 */
    "'E5' check printed       ", /* 348 E6 */
    "'E6' reserved            ", /* 349 E7 */
    "'E7' check printed       ", /* 350 E8 */
    'Certified Check Clearing ', /* 351 SH */
    'Promotional Prize        ', /* 352 PZ */
    'Shared Branch Usage Fee  ', /* 353 BU */
    'Safe Deposit Box Fee     ', /* 354 BX */
    'Market Index Dividend    ', /* 355 ID */
    'Sale of Collateral       ', /* 356 AA */
    'Home Withdrawal-Transfer ', /* 357 H1 */
    'Home Deposit-Transfer    ', /* 358 H2 */
    'Home Payment-Transfer    ', /* 359 H3 */
    'Home Loan-Advance        ', /* 360 H4 */
    'Home VISA-Payment        ', /* 361 H5 */
    'ReCharacterized Contribut', /* 362 ZA */
    'ReCharacterized Earnings ', /* 363 ZB */
    'ReCharacterized Rollover ', /* 364 ZX */
    'ReCharacterized Dividend ', /* 365 ZY */
    "'ATM' POS-DebitAdjustment", /* 366 WA */
    "'ATM' POS-Credit-Adjust  ", /* 367 80 */
    'Compensate/Reimbursement ', /* 368 CX */
    'IRA DIVIDEND PENALTY     ', /* 369 IY */
    'Inactive Account Fee     ', /* 370 IV */
    'Monthly Interest Added   ', /* 371 MN */
    'Annual-Membership-Fee    ', /* 372 NN */
    'Check-Cashing-Fee        ', /* 373 F8 */
    'Funds Recd Misc Income #1', /* 374 X4 */
    'Funds Recd Misc Income #2', /* 375 X5 */
    'Funds Recd Misc Income #3', /* 376 X6 */
    'Funds Recd Misc Income #4', /* 377 X7 */
    'Funds Recd Misc Income #5', /* 378 X8 */
    'Cert-Dividend-Transfer   ', /* 379 CZ */
    "'ACH'-Overdraft-Fee      ", /* 380 A1 */
    "'ACH'-Overdraft-Xfer-Fee ", /* 381 A2 */
    "'ACH'-Advance-Fee        ", /* 382 A3 */
    'ReDeposit Void MoneyOrder', /* 383 VM */
    'ReDeposit Void Certified ', /* 384 VS */
    'ReDeposit Void Corporate ', /* 385 VT */
    'Late-Fee-Payment-Received', /* 386 G1 */
    'Late-Fee-Payment-Transfer', /* 387 G2 */
    'Returned Mail Fee        ', /* 388 AI */
    "'ACH'-Check-Payment      ", /* 389 A4 */
    "'ACH'-NSF-Return         ", /* 390 A6 */
    "'ACH'-Stop-Pay-Return    ", /* 391 A7 */
    'Share Dividend Adjustment', /* 392 DX */
    "'ACH' G.L. TRANSACTION   ", /* 393 GL */
    "'ACH' LOAN PAYMENT       ", /* 394 A8 */
    "'ACH'-G.L. Transaction   ", /* 395 A9 */
    'Western-Union Wire Wthdwl', /* 396 WW */
    'Western-Union Wire Fee   ', /* 397 WU */
    'Loan GAP Insurance-Prem  ', /* 398 GA */
    'Share Deposit (Mail)     ', /* 399 MD */
    'VISA-Payment (Mail)      ', /* 400 MV */
    'Loan payment (Mail)      ', /* 401 LM */
    'Teller Paid Draft (MAIL) ', /* 402 TB */
    'Loan-NOTE-NUMBER-change..', /* 403 NQ */
    'Share-TYPE-change...     ', /* 404 TQ */
    'Account-NUMBER-change... ', /* 405 MQ */
    "'ATM' Pre-Authorized HOLD", /* 406 HQ */
    "'ATM' PreAuthorized CLEAR", /* 407 QQ */
    'VISA CreditBalance Refund', /* 408 VR */
    'Charitable Contribution  ', /* 409 CH */
    "IRA 'SEP' Employer Credit", /* 410 IZ */
    "'ACH'-G.L. Transaction   ", /* 411 A5 */
    'G.L. Funds Description   ', /* 412 GF */
    'StateTaxWthhld(NormalDis)', /* 413 Z1 */
    'StateTaxWthhld(EarlyWdwl)', /* 414 Z2 */
    'StateTaxWthhld(EqualPymt)', /* 415 Z3 */
    "'ATM' EXCEEDED STAND-IN  ", /* 416 N1 */
    "'ATM' NSF SEQUENCE HOLDER", /* 417 N2 */
    "'ATM' PRE-AUTH SEQ HOLDER", /* 418 N3 */
    "'ATM' UN-POSTABLE ITEM   ", /* 419 N4 */
    'ShareLoan Transfer Detail', /* 420 MS */
    'Share Collection Fee     ', /* 421 EF */
    'Shared-Branch-Visa-Pymt  ', /* 422 PY */
    'Card-Advance/Loan-Payment', /* 423 PA */
    'PHONE/FAX Charge         ', /* 424 XO */
    'Loan Interest Rebate     ', /* 425 BT */
    'Foreign Exchange Fee     ', /* 426 EX */
    'e-Bill Fee               ', /* 427 EB */
    'Home-Bank Charge         ', /* 428 KG */
    "'ACH' Hand-Posting-Fee   ", /* 429 HP */
    'Courtesy-Pay-Fee         ', /* 430 YF */
    'Branch Fee/Charge        ', /* 431 SB */
    'Loan-Reqd-Payment-Change ', /* 432 PQ */
    'Loan Postage Charge      ', /* 433 PG */
    'Share Postage Charge     ', /* 434 HG */
    'Paper-Statement-Fee      ', /* 435 NE */
    'Open-HSA-(Health-Savings)', /* 436 O7 */
    'Share Deposit (Advance)  ', /* 437 SX */
    'PrePaid Card Purchase    ', /* 438 C9 */
    'PrePaid Card Fee         ', /* 439 C0 */
    "'ATM' Refund Fee         ", /* 440 R1 */
    "'ACH' Refund Fee         ", /* 441 R2 */
    'Refund Draft Fee         ', /* 442 R3 */
    'Branch Deposit From Share', /* 443 1B */
    'Branch Transfer To Share ', /* 444 2B */
    'Branch Payment From Share', /* 445 3B */
    'Branch Transfer To Loan  ', /* 446 4B */
    'Branch Advance To Share  ', /* 447 5B */
    'Branch Transfer From Loan', /* 448 6B */
    'Home-Equity Card Advance ', /* 449 HA */
    'Home-Equity Card Payment ', /* 450 QP */
    'Collateral Surrendered   ', /* 451 L2 */
    'Collateral Foreclosed    ', /* 452 L3 */
    'CPI Insurance Refund     ', /* 453 L4 */
    'CPI Insurance Refund     ', /* 454 L5 */
    'Attorney Fee on Judgement', /* 455 FJ */
    'Contribution (Rollover)  ', /* 456 1H */
    'Contribution (Prior-Year)', /* 457 2H */
    'HSA - reserved           ', /* 458 3H */
    'Contribution RolloverXfer', /* 459 4H */
    'ContributionPriorYearXfer', /* 460 5H */
    'EmployerDepositCurrentYR ', /* 461 6H */
    'EmployerDepositPriorYEAR ', /* 462 7H */
    'Normal Distribution Check', /* 463 1F */
    'Normal Distribution Xfer ', /* 464 2F */
    'Withdrawal-Rollover-Xfer ', /* 465 3F */
    'HSA - reserved           ', /* 466 4F */
    'Withdrawal Excess Earning', /* 467 5F */
    'HSA Maintenance Fee      ', /* 468 6F */
    'Distribution (Disability)', /* 469 7F */
    'Rollover Distribution    ', /* 470 8F */
    'WithdrawExcessContributon', /* 471 9F */
    'HSA - reserved           ', /* 472 0F */
    'HSA DIVIDEND PENALTY     ', /* 473 1D */
    'HSA - reserved           ', /* 474 2D */
    'HSA Distribution (YOD)   ', /* 475 3D */
    'HSA Distribution (NYOD)  ', /* 476 4D */
    'HSA Checking Transfer    ', /* 477 5D */
    'Coin Machine Deposit     ', /* 478 1C */
    'Open-HSA-Certificate     ', /* 479 O8 */
    "'ACH'-Miscellaneous-Fee  ", /* 480 R4 */
    "'ACH' Returned-Fee       ", /* 481 R5 */
    "'ACH'-Returned-Fee       ", /* 482 R6 */
    "'ACH'-Stop-Pay-Fee       ", /* 483 R7 */
    "'ACH'-Origination-Fee    ", /* 484 R8 */
    "'ACH' Origination-Fee    ", /* 485 R9 */
    'Partial Charge-Off       ', /* 486 CQ */
    'Closed-Loan-Account      ', /* 487 L6 */
    'ReOPEN prior CLOSED share', /* 488 RO */
    'Branch (local check)     ', /* 489 B9 */
    'Branch (non-local check) ', /* 490 9B */
    'Branch (immediate check) ', /* 491 8B */
    "CHECK-DEPOSIT-'HOLD'     ", /* 492 HX */
    "SHARE-'HOLD'-CHANGE      ", /* 493 HY */
    "'ATM' CROSS-BORDER-FEE   ", /* 494 N5 */
    'Express Delivery Charge  ', /* 495 EC */
    'Debit-Card (NSF) Fee     ', /* 496 MX */
    'Debit-Card-Transfer-Fee  ', /* 497 XZ */
    'Ticket-Purchase-Type#5   ', /* 498 T5 */
    'Ticket-Purchase-Type#6   ', /* 499 T6 */
    'Ticket-Purchase-Type#7   ', /* 500 T7 */
    'Ticket-Purchase-Type#8   ', /* 501 T8 */
    'Ticket-Purchase-Type#9   ', /* 502 T9 */
    'Item Purchase #4         ', /* 503 I4 */
    'Item Purchase #5         ', /* 504 I5 */
    'Item Purchase #6         ', /* 505 I6 */
    'Item Purchase #7         ', /* 506 I7 */
    'Item Purchase #8         ', /* 507 I8 */
    'Legal Fee                ', /* 508 AZ */
    'Charge-off Loan Reversal ', /* 509 OZ */
    'VISA/POS Card ChargeBack ', /* 510 VA */
    'VISA Credit Adjustment   ', /* 511 VB */
    'VISA Debit Adjustment    ', /* 512 VE */
    'Savings-(Draft)-Posted   ', /* 513 SU */
    'Savings-(Draft)-Returned ', /* 514 ZU */
    'ReDeposit NSF Check      ', /* 515 VN */
    'Share-Stop-Payment-Fee   ', /* 516 SZ */
    'Phone-Withdrawal-Transfer', /* 517 X9 */
    'Phone-requested-check    ', /* 518 K9 */
    'Phone Deposit Transfer   ', /* 519 S7 */
    'Phone Withdrawal-Transfer', /* 520 S6 */
    'Home Withdrawal-Transfer ', /* 521 H6 */
    "'ATM'-Inquiry Access     ", /* 522 N6 */
    "'POS'-Usage-Fee          ", /* 523 PU */
    'Skip-A-Payment           ', /* 524 KP */
    'Loan-Extension-Granted   ', /* 525 EG */
    "'ACH'-Bill-Payer-Return  ", /* 526 G8 */
    "'ACH'-Bill-Pay-Return-Fee", /* 527 G9 */
    'memo/message line        ', /* 528 MM */
    'Collateral Sale Gain/Loss', /* 529 AB */
    'IDENTITY-THEFT-PROTECTION', /* 530 IT */
    'ReOPEN prior CLOSED loan ', /* 531 RN */
    'Write-Off CourtesyPay/ODP', /* 532 WX */
    'Skip-A-Payment FEE       ', /* 533 KX */
    'Payment Date Advance Fee ', /* 534 NX */
    'Scholarship Funding      ', /* 535 SS */
    'BackupWithholding Payable', /* 536 P6 */
    'Medicare TaxDeposit Paybl', /* 537 P7 */
    'SocSec TaxDeposit Payable', /* 538 P8 */
    'Federal Tax-Deposit Paybl', /* 539 P9 */
    'Overdraft-Service-Fee    ', /* 540 FE */
    'Offsite Mortgage Payment ', /* 541 OM */
    "'ACH'-RETURNED-ITEM      ", /* 542 VZ */
    'Stop-Payment-Return      ', /* 543 XN */
    'Phone-Requested-Xfer-Fee ', /* 544 XQ */
    '=========================', /* 545 ZZ */
    'IRA Conversion Transfer  ', /* 546 Z4 */
    'IRA Conversion Transfer  ', /* 547 Z5 */
    '=========================', /* 548 QZ */
    'E-Statement Credit       ', /* 549 W1 */
    'High Balance Credit      ', /* 550 W2 */
    'Direct Deposit Credit    ', /* 551 W3 */
    'Free-Trial-Refund        ', /* 552 W4 */
    'CW Checking Cost         ', /* 553 W5 */
    'HV Checking Cost         ', /* 554 W6 */
    'Subpena Fee              ', /* 555 W7 */
    'Special Handling Fee     ', /* 556 W8 */
    "ACH 'IAT' Transaction Fee", /* 557 W9 */
    'Hand Posting Fee (Draft) ', /* 558 W0 */
    'Application Fee          ', /* 559 WZ */
    'ESCHEAT FEE TO STATE     ', /* 560 ES */
    'INVALID ADDRESS FEE      ', /* 561 FV */
    'Statement History Fee    ', /* 562 HS */
    'Bulk Coin Fee            ', /* 563 BC */
    'Card-Advance/Loan-Payment', /* 564 KA */
    'Voucher-Full - Continued ', /* 565 VF */
    'Unemployment Insurance   ', /* 566 UI */
    'PMI/MIP Mortgage-Insuranc', /* 567 IM */
    'Wthdrwl Club Payout Xfer ', /* 568 E0 */
    'Deposit Club Payout Xfer ', /* 569 E9 */
    'Mechanical-RepairCoverage', /* 570 MH */
    "'Move' Entire transaction", /* 571 MO */
    'Promotional Payment      ', /* 572 OO */
  ];
  return trc[code];
}
export default getTR;



// WEBPACK FOOTER //
// ./src/trnum.js